import { render } from "./SliderCheckbox.vue?vue&type=template&id=56673517&scoped=true"
import script from "./SliderCheckbox.vue?vue&type=script&lang=js"
export * from "./SliderCheckbox.vue?vue&type=script&lang=js"

import "./SliderCheckbox.vue?vue&type=style&index=0&id=56673517&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56673517"]])

export default __exports__